import { useMemo, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Hot from "./components/Hot";
import Lexicon from "./components/Lexicon";
import DeepRead from "./components/DeepRead";
import Facts from "./components/Facts";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import TermModal from "./components/TermModal";
import ReadModal from "./components/ReadModal";
import BackToTop from "./components/BackToTop";
import { terms } from "@/mocks/terms";
import { findTermByTitle } from "./dataTypes";
import type { Term, FeaturedRead } from "./dataTypes";

const termList = terms as Term[];

function scrollToLexicon() {
  document.getElementById("lexicon")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

// 站点级结构化数据
const siteSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "吃瓜百科",
      url: "https://centricube.cn/",
      description: "用通俗语言解释热点事件中的网络术语、流行梗与典故来源的科普内容站。",
    },
    {
      "@type": "WebSite",
      name: "吃瓜百科",
      url: "https://centricube.cn/",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://centricube.cn/?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      name: "吃瓜百科 - 吃瓜科普术语解释与名词速览",
      url: "https://centricube.cn/",
      inLanguage: "zh-CN",
    },
  ],
};

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [activeTerm, setActiveTerm] = useState<Term | null>(null);
  const [activeRead, setActiveRead] = useState<FeaturedRead | null>(null);

  const relatedTerms = useMemo(() => {
    if (!activeTerm) return [];
    return activeTerm.related
      .map((title) => findTermByTitle(termList, title))
      .filter((t): t is Term => Boolean(t));
  }, [activeTerm]);

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    scrollToLexicon();
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <Hot onQuery={handleSearch} />
        <Lexicon keyword={keyword} setKeyword={setKeyword} onPickTerm={setActiveTerm} />
        <DeepRead onOpen={setActiveRead} />
        <Facts />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />

      {activeTerm && (
        <TermModal
          key={activeTerm.id}
          term={activeTerm}
          relatedTerms={relatedTerms}
          onPick={setActiveTerm}
          onClose={() => setActiveTerm(null)}
        />
      )}
      {activeRead && <ReadModal read={activeRead} onClose={() => setActiveRead(null)} />}
    </>
  );
}